<template>
  <b-modal
    id="assign-assessor-modal"
    v-model="$show"
    centered
    no-close-on-backdrop
    no-close-on-esc
    size="md"
    :title="`Assign ${evidenceSubmissionIds.length} submission to assessor`"
  >
    <span v-if="owner">
      <b-form-radio v-model="selectedAssessor" :value="owner.userId" class="radio__assessors">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <base-user-profile :user-name="userFullName(owner)" :picture="owner.profile_picture">
            <template slot="name">
              <div class="ml-2 my-2">
                <div class="text-primary font-weight-bold">
                  {{ userFullName(owner) }}
                </div>
                <div class="text-dark small">
                  {{
                    `${
                      owner.count_of_submissions ? owner.count_of_submissions : 0
                    } Pending to assess`
                  }}
                </div>
              </div>
            </template>
          </base-user-profile>
          <base-tag :tag="owner.tag" />
        </div>
      </b-form-radio>
    </span>
    <hr v-if="assessors.length" />
    <span v-for="assessor in assessors" :key="assessor.id" class="radio__assessors">
      <span v-if="assessor">
        <b-form-radio v-model="selectedAssessor" :value="assessor.userId">
          <div class="d-flex flex-row mb-3 align-items-center justify-content-between">
            <base-user-profile
              :user-name="userFullName(assessor)"
              :picture="assessor.profile_picture"
            >
              <template slot="name">
                <div class="ml-2 my-2">
                  <div class="text-primary font-weight-bold">
                    {{ userFullName(assessor) }}
                  </div>
                  <div class="text-dark small">
                    {{
                      `${
                        assessor.count_of_submissions ? assessor.count_of_submissions : 0
                      } Pending to assess`
                    }}
                  </div>
                </div>
              </template>
            </base-user-profile>
            <base-tag :tag="assessor.tag" />
          </div>
        </b-form-radio>
      </span>
    </span>

    <template #modal-footer="{ cancel }">
      <b-button :disabled="isLoading" @click="cancel()">Cancel</b-button>
      <b-button
        variant="success"
        :disabled="isLoading || !selectedAssessor"
        @click="confirmAssign()"
      >
        <b-spinner v-if="isLoading" label="Loading..." small />
        <span v-else>Confirm</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import UserRole from '@/models/UserRole';
import LearningUnitMember from '@/models/LearningUnitMember';
import BaseUserProfile from '../base-components/BaseUserProfile.vue';
import BaseTag from '../base-components/BaseTag.vue';
import EvidenceSubmission from '@/models/EvidenceSubmission';
export default {
  components: {
    BaseUserProfile,
    BaseTag
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    evidenceSubmissionIds: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      selectedAssessor: null,
      owner: null,
      assessors: [],
      isLoading: false
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },

    learningUnitId() {
      return parseInt(this.$route.params.learningUnitId);
    }
  },

  watch: {
    '$route.path': {
      immediate: true,
      handler: 'onRouteChanged'
    }
  },

  methods: {
    async onRouteChanged() {
      await this.fetchAssessors();
    },
    async fetchAssessors() {
      try {
        const {
          response: { data }
        } = await LearningUnitMember.api().fetchWithSubmissions({
          learningUnitId: this.learningUnitId
        });

        const owner = data.find((d) => UserRole.find(d.user_role).role === 'lu_owner');
        this.owner = {
          id: owner.id,
          firstname: owner.user.firstname,
          lastname: owner.user.lastname,
          email: owner.user.email,
          tag: UserRole.find(owner.user_role).role,
          userId: owner.user ? owner.user.id : null,
          profile_picture: owner.user ? owner.user.profile_picture : null,
          count_of_submissions: owner.count_of_submissions
        };
        this.assessors = data
          .filter((d) => UserRole.find(d.user_role).role === 'lu_assessor')
          .map((record) => {
            return {
              id: record.id,
              firstname: record.user.firstname,
              lastname: record.user.lastname,
              email: record.user.email,
              tag: UserRole.find(record.user_role).role,
              userId: record.user ? record.user.id : null,
              profile_picture: record.user ? record.user.profile_picture : null,
              count_of_submissions: record.count_of_submissions
            };
          });
      } catch (error) {
        console.error(error);
        this.$toast.error('Cannot load assessors, please try again');
      }
    },
    userFullName(user) {
      return `${user.firstname} ${user.lastname}`;
    },
    async confirmAssign() {
      if (!this.selectedAssessor) {
        return this.$toast.error('Please select an assessor');
      }

      if (this.evidenceSubmissionIds.length === 0) {
        return this.$toast.error('Please select at least one submission');
      }

      this.isLoading = true;
      const body = this.evidenceSubmissionIds.map((id) => {
        return {
          id,
          assessor: this.selectedAssessor
        };
      });
      try {
        await EvidenceSubmission.api().assignAssessor(body);
        await this.fetchAssessors();
        this.$emit('assign-success');
        this.$toast.success('Assessor assigned successfully');
        this.$bvModal.hide('assign-assessor-modal');
      } catch (error) {
        console.error(error);
        this.$toast.error('Cannot assign assessor, please try again');
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
<style lang="scss">
.radio__assessors .custom-control-label {
  width: 100%;
}
.radio__assessors .custom-control-label::before,
.radio__assessors .custom-control-label::after {
  top: 1.1rem;
}
</style>
